import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { UnidadFuncionalService } from '../../../../../src/app/shared/services';
import { ImportUnidadFuncionalPersonaExcelRequestDto, SaveUnidadFuncionalPersonaRelacionDto } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-dialog-unidad-funcional-persona-import',
  templateUrl: './dialog-unidad-funcional-persona-import.component.html',
  styleUrls: ['./dialog-unidad-funcional-persona-import.component.scss']
})

export class DialogUnidadFuncionalPersonaImportComponent implements OnInit {

    isImporting: boolean = false;
    isExporting: boolean = false;

    fileBase64: string | ArrayBuffer | null;
    fileName: string = "";
    cId:number;
    ufsList:SaveUnidadFuncionalPersonaRelacionDto[];

    //public input:DialogUnidadFuncionalPersonaImportComponent = Inject(MAT_DIALOG_DATA);


    constructor(
      private dialogRef: MatDialogRef<DialogUnidadFuncionalPersonaImportComponent>,
      @Inject(MAT_DIALOG_DATA) public input: DialogUnidadFuncionalPersonaImportComponent,
      private sharedFunctions: SharedFunctions,
      private service: UnidadFuncionalService
    ) {

    }

    ngOnInit(): void {

    }

    isProcessing() {
        return (this.isImporting || this.isExporting);
      }

    convertFileToBase64(event) {
      this.fileBase64 = null;
      this.fileName = '';

      const file = event.target.files[0];

      if (file != null) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {};
        reader.onloadend = () => {
          this.fileBase64 = reader.result;
          this.fileName = file?.name;
        };
      }
    }

    onImportar() {
      var r = new ImportUnidadFuncionalPersonaExcelRequestDto(this.fileName, this.fileBase64, this.input.cId, this.input.ufsList);
      
      this.isImporting = true;
      this.service.importUfsPersonasFromExcel(r).subscribe(data => {
        this.isImporting = false;
        if (data != null && data.Success && data.Result != null){
          this.sharedFunctions.showMessage("Se crearon "+ data.Result.Count + " Unidades Funcionales nuevas.", "Importación de Archivo");

          this.onAccept();
        }
        else
          this.sharedFunctions.showMessage("Ocurrió un error realizando la importación", "Importación de Archivo");

      },
      (err: HttpErrorResponse) => {
        this.isImporting = false;
        this.sharedFunctions.handleError(err, true);
      });
    }

    onDownloadImportTemplate() {
      this.isExporting = true;
      this.service.downloadImportPropietariosTemplate().subscribe((data: Blob) => {
        this.isExporting = false;
        var fileUrl = URL.createObjectURL(data);

        var anchor = document.createElement("a");
        anchor.download = "TemplateImportacion_Ufs_Personas.xlsx";
        anchor.href = fileUrl;
        anchor.click();
      },
      (err: HttpErrorResponse) => {
        this.isExporting = false;
        this.sharedFunctions.handleError(err, true);
      })
    }

    onCancel() {
      this.dialogRef.close(null);
    }

    onAccept() {
      this.dialogRef.close({Accepted: true});
    }
}
